// ABOUTME: Phone-view card for an invoice product category row (name + product count)
// ABOUTME: Rendered inside the ProductCategories datagrid on small screens
import { Box, useTheme } from "@mui/material";
import BaseCard from "../../../theme/cards/BaseCard";
import Text from "../../../theme/text/Text";
import { tokens } from "../../../../theme";
import { useTranslation } from "react-i18next";

export const WarehouseInvoiceProductCategoryCard = (props) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t,i18n } = useTranslation();

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    {/* Top row */}
                    <Box
                        sx={{
                            display:"flex",
                            justifyContent:"space-between",
                            gap:3,
                        }}
                    >
                        <Box sx={{ flexGrow: 1, flexShrink: 1, overflow:"hidden" }}>
                            <Box>
                                <Box>
                                    <Text bold>{props.name}</Text>&nbsp;
                                </Box>
                            </Box>
                            <Box>
                                <Text>{props.invoiceProducts?.length || 0}</Text>&nbsp;
                                <Text light>{t("invoice_products")}</Text>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}
